export default "__VITE_ASSET__CSQeK6Qh__"